<template>
  <!-- el-toolTip组件封装多行文本超出隐藏 -->
    <el-tooltip :content="txtInfo" :placement="placement" :effect="effect" :disabled="isShow">
　　　　　<!-- :style="dynamicSty"动态绑定样式  -->
        <div class="contentnowrap" :style="dynamicSty" :class="{isLink: 'link-text'}" @mouseenter="isShowTooltip" @click="linkTo">
          <span ref="contentRef">{{ txtInfo }}</span>
        </div>
    </el-tooltip>
</template>

<script>
export default {
  name: 'toolTip',
  props: {
    // 内容
    txtInfo: {
      type: String,
      default: ''
    },
    // 行数
    num: {
      type: Number,
      default: 1
    },
    // 提示语背景色
    effect: {
      type: String,
      default: 'dark'
    },
    // 提示语方向
    placement: {
      type: String,
      default: 'top'
    },
    isLink: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShow: false,
      dynamicSty: {
        '-webkit-line-clamp': this.num // 这里是超出几行省略
      }
    }
  },
  methods: {
    isShowTooltip (e) {
      const clientHeight = e.target.clientHeight
      const scrollHeight = e.target.scrollHeight
      const arrList = Array.from(e.target.classList)
　　　　// 文字超出隐藏并弹出tooltip提示，文字未超出则不弹出tooltip提示的判断条件
      if (scrollHeight > clientHeight && this.$refs.contentRef.parentNode.offsetWidth > this.$refs.contentRef.offsetWidth) {
        this.isShow = false
        if (!arrList.includes('hover-blue')) {
          e.target.classList.add('hover-blue')
        }
      } else {
        this.isShow = true
        e.target.classList.remove('hover-blue')
      }
    },
    linkTo () {
      if (this.isLink) {
        this.$emit('linkTo')
      }
    }
  }
}
</script>

<style lang="scss">
.contentnowrap{
  padding: 2px 0;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.link-text{
  cursor: pointer;
}
.el-tooltip__popper{
  font-size: 14px;
}
</style>